import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';

import { I18nDataLoadingService } from './i18n-data-loading.service';
import { MultiTranslateHttpLoader } from './multi-translate-http-loader';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    HttpClientModule,
    TranslateModule.forRoot({
      defaultLanguage: 'fr',
      useDefaultLang: true,
      loader: {
        provide: TranslateLoader,
        useClass: MultiTranslateHttpLoader,
        deps: [I18nDataLoadingService],
      },
    }),
  ],
  exports: [TranslateModule],
})
export class CustomTranslateModule {}
